var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v("\n  立壕有限公司 Copyright @ 2022\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }